import React, {} from 'react';
function GmailGlyph({ size }) {
    return (React.createElement("svg", { viewBox: "0 0 24 24", width: size, height: size, xmlns: "http://www.w3.org/2000/svg", "aria-label": "Gmail" },
        React.createElement("path", { fill: "#EA4335", d: "M4 5h16c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z" }),
        React.createElement("path", { fill: "#fff", d: "M2 7l10 7 10-7" })));
}
function SlackGlyph({ size }) {
    return (React.createElement("svg", { viewBox: "0 0 24 24", width: size, height: size, xmlns: "http://www.w3.org/2000/svg", "aria-label": "Slack" },
        React.createElement("rect", { x: "2", y: "8", width: "7", height: "3", rx: "1.5", fill: "#36C5F0" }),
        React.createElement("rect", { x: "15", y: "8", width: "7", height: "3", rx: "1.5", fill: "#ECB22E" }),
        React.createElement("rect", { x: "2", y: "13", width: "7", height: "3", rx: "1.5", fill: "#E01E5A" }),
        React.createElement("rect", { x: "15", y: "13", width: "7", height: "3", rx: "1.5", fill: "#2EB67D" }),
        React.createElement("rect", { x: "9", y: "2", width: "3", height: "7", rx: "1.5", fill: "#ECB22E" }),
        React.createElement("rect", { x: "9", y: "15", width: "3", height: "7", rx: "1.5", fill: "#2EB67D" }),
        React.createElement("rect", { x: "12", y: "2", width: "3", height: "7", rx: "1.5", fill: "#36C5F0" }),
        React.createElement("rect", { x: "12", y: "15", width: "3", height: "7", rx: "1.5", fill: "#E01E5A" }),
        React.createElement("rect", { x: "9", y: "8", width: "3", height: "3", fill: "#ECB22E" }),
        React.createElement("rect", { x: "12", y: "8", width: "3", height: "3", fill: "#36C5F0" }),
        React.createElement("rect", { x: "9", y: "13", width: "3", height: "3", fill: "#2EB67D" }),
        React.createElement("rect", { x: "12", y: "13", width: "3", height: "3", fill: "#E01E5A" })));
}
function strokeIcon(paths) {
    return function StrokeGlyph({ size }) {
        return (React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }, paths));
    };
}
const SettingsGlyph = strokeIcon(React.createElement(React.Fragment, null,
    React.createElement("circle", { cx: "12", cy: "12", r: "3" }),
    React.createElement("path", { d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" })));
const ChevronRightGlyph = strokeIcon(React.createElement("path", { d: "m9 18 6-6-6-6" }));
const LogOutGlyph = strokeIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" }),
    React.createElement("path", { d: "M16 17l5-5-5-5" }),
    React.createElement("path", { d: "M21 12H9" })));
const UsersGlyph = strokeIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }),
    React.createElement("circle", { cx: "9", cy: "7", r: "4" }),
    React.createElement("path", { d: "M22 21v-2a4 4 0 0 0-3-3.87" }),
    React.createElement("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" })));
const SparklesGlyph = strokeIcon(React.createElement("path", { d: "M12 3l1.9 4.8L19 9.5l-5.1 1.7L12 16l-1.9-4.8L5 9.5l5.1-1.7L12 3z" }));
const DownloadGlyph = strokeIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
    React.createElement("path", { d: "M7 10l5 5 5-5" }),
    React.createElement("path", { d: "M12 15V3" })));
const BellGlyph = strokeIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" }),
    React.createElement("path", { d: "M13.73 21a2 2 0 0 1-3.46 0" })));
const GLYPHS = {
    gmail: GmailGlyph,
    slack: SlackGlyph,
    settings: SettingsGlyph,
    'chevron-right': ChevronRightGlyph,
    'log-out': LogOutGlyph,
    users: UsersGlyph,
    sparkles: SparklesGlyph,
    download: DownloadGlyph,
    bell: BellGlyph
};
export function Icon({ name, size = 24, tint }) {
    const Glyph = GLYPHS[name];
    if (tint === undefined) {
        return React.createElement(Glyph, { size: size });
    }
    return (React.createElement("span", { style: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: tint,
            borderRadius: '50%',
            padding: Math.round(size * 0.25)
        } },
        React.createElement(Glyph, { size: size })));
}
//# sourceMappingURL=Icon.js.map